import React from 'react'
import {Link} from 'react-router-dom'
import { FaYoutube } from "react-icons/fa";


const more_Links=["/videolist/annamayya-8.html","/videolist/ayyappaswamideeksha-37.html","/videolist/drananthalakshmi-23.html",
  "/videolist/drmuktevibharathi-39.html","/videolist/mangalaharathulu-40.html","/videolist/manjulasri-24.html",
  "/videolist/mylavarapusrinivasarao-32.html","/videolist/shivastotram-35.html","/videolist/sridevibhagavatham-9.html",
  "/videolist/sriramanavamivideos-36.html","/videolist/stotralu-33.html","/videolist/tiruppavai-34.html"
]


const MoreRelated = ({item,subCat}) => {
          
 const get_Page_link = () => {

  const link = more_Links.find((l) => l.includes(subCat));
  return link || null; 
};




        
  return (  
    
    <div className='row g-0 mb-3'>
    
                  <div className='col-12 devotional-videos-header'>More</div>
                {Array.isArray(item) && item.map((item,index) =>
                      
                  <div key={index} className="col-6 col-sm-4 col-md-3">
                    <figure className="devotional-videos-item">
                        <Link to={item.related_url ? item.related_url.substring(item.related_url.indexOf('/devotional')+11) : ''}>
                        <img src={item.related_image_url ? item.related_image_url : '/devotional/assets/images/error_img.webp'} alt="Description of img 1" /></Link>
                        <FaYoutube className='dvi-icon' />
                        <figcaption ><Link to={item.related_url ? item.related_url.substring(item.related_url.indexOf('/devotional')+11) : ''}>{item.related_title ? item.related_title : 'Title'}</Link></figcaption>
                    </figure>
                </div>  
                  ) } 
    
                  <div className='col-12 d-flex justify-content-end'>
                            <button className='devotional-videos-more-btn'>
                            <Link to={get_Page_link()}>More</Link></button>
                  </div>
    
     </div>  
  )
}

export default MoreRelated;
